import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import Person from "../../../types/Person"
import DateTimeListItem from "../../common/ListItems/DateTime";

export interface componentProps {
    item: Person
}

const ItemGroupInfo: React.FC<componentProps> = ({item} ) => {

    const {t} = useTranslation()

    return (
        <IonItemGroup>
            <IonItemDivider>{t('people.form.contact_info')}</IonItemDivider>
            <IonItem lines="full">
                <IonLabel>{t('people.form.email')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.email || '-'}</IonNote>
            </IonItem>
            <IonItem lines="full">
                <IonLabel>{t('people.form.mobile')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.phone1 || '-'}</IonNote>
            </IonItem>
            {item.companyName &&
                <IonItem lines="full">
                    <IonLabel>{t('people.form.company_name')}</IonLabel>
                    <IonNote className="ion-padding-vertical" slot="end">{item.companyName}</IonNote>
                </IonItem>
            }
            {item.meta?.syncedAt &&
                <DateTimeListItem label={t('common.synced_at').toString()}
                                  dateTime={item.meta.syncedAt} />
            }
        </IonItemGroup>
    )
}

export default ItemGroupInfo